module.exports = __webpack_public_path__ + "img/card.5492751b.png";